import * as basicScroll from 'basicscroll'

let parallax_instances = [];

export function handleParallaxSections() {
    let $section = $('.js-parallax-section');
    if ($section.length === 0) {
        return;
    }
    $section.each(function () {
        let $anchor = $(this).find('.js-parallax-anchor');
        let elem = $anchor.length === 0 ? this : $anchor[0];
        handleParallaxSection(this, elem);
    });
}

export function handleParallaxSection(section, elem) {
    let $parallax_elems = $(section).find('.js-parallax-element');
    let customDistance = $(section).attr('data-transition-amount');
    if ($parallax_elems.length === 0) {
        return;
    }
    $parallax_elems.each(function () {
        parallax_instances.push(createParallaxInstance(elem, this, customDistance));
    });
    parallax_instances.forEach((parallax_instance) => parallax_instance.start())
    window.onresize = function () {
        parallax_instances.forEach((parallax_instance) => {
            parallax_instances.calculate()
            parallax_instances.update()
        });
    }
}

export function createParallaxInstance(elem, direct, customDistance = undefined) {
    let to = customDistance !== undefined ? customDistance : '200px';

    return basicScroll.create({
        elem: elem,
        from: 'top-top',
        to: 'bottom-top',
        direct: direct,
        props: {
            '--ty': {
                from: '0',
                to: to,
                timing: 'linear'
            }
        }
    });
}
